import { gql } from '@apollo/client'

export const CREATE_FUEL_TYPE = gql`
  mutation createFuelType($input: CreateFuelTypeInput!) {
    data: createFuelType(input: $input) {
      id
    }
  }
`
